import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpListItemComponent from './adpListItem.component';

let adpListItemModule = angular.module('adpListItem', [
  uiRouter
])

.component('adpListItem', adpListItemComponent)

.name;

export default adpListItemModule;



// WEBPACK FOOTER //
// ./src/app/components/adpListItem/adpListItem.js